import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronDown24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.0477 16.5C12.3985 16.5 12.6992 16.3488 12.8996 16.0967L17.7606 10.5515C18.1114 10.1986 18.0613 9.59368 17.7105 9.2408C17.3597 8.88792 16.7584 8.93833 16.4076 9.29121C16.4076 9.29121 16.4076 9.29121 16.3575 9.34162L12.0978 14.1811C12.0477 14.2315 11.9976 14.2315 11.8974 14.1811L7.63776 9.34162C7.28696 8.93833 6.73572 8.88792 6.33481 9.2408C5.93391 9.59368 5.88379 10.1482 6.23459 10.5515C6.23459 10.5515 6.23459 10.5515 6.2847 10.6019L11.1457 16.1471C11.3962 16.3488 11.6969 16.5 12.0477 16.5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
